<template>
  <div class="page__wrapper" @scroll="onScroll()">
    <FCCopy :h2="this.h2" :h3="this.h3">
      <template v-slot:copy>
        <strong
          class="bigger"
        >The Bailey has been called the best supporters’ section in the United States – the energy, the drums, the smoke, the chants. And it’s about to get even better at West End Stadium in 2021. Thanks to design input from the very supporters who built the club to its current identity, The Bailey at West End Stadium will amplify the intense, energetic gameday experience.</strong>
        <p class="margin-top biggers">
          <strong>
            FC Cincinnati has announced that season ticket pricing in The Bailey will remain flat, with
            <span
              class="orange"
            >season tickets costing less than $20 per match.</span>
          </strong>
        </p>
        <p class="map">
          <img
            src="~@/assets/maps/map-bailey.png"
            alt
            data-aos="zoom-in-up"
            data-aos-duration="250"
            data-aos-easing="ease-out-cubic"
          />
        </p>
      </template>
    </FCCopy>
  </div>
</template>

<script>
import FCCopy from "@/components/patterns/FCCopy";
export default {
  components: {
    FCCopy,
  },
  mounted() {
    const ref = this.$store.state.menu.bailey.ref;
    const index = this.$store.state.menu.menuItems
      .map((e) => e.ref)
      .indexOf(ref);
    this.$store.state.menu.activeSection = index;
    this.$store.state.menu.currentSectionTitle = this.$store.state.menu.bailey.title;
    this.$store.state.menu.currentSectionNavigation = this.$store.state.menu.bailey.nav;
    this.onScroll();
  },
  data() {
    return {
      h2: "The Bailey",
      h3: "Intro",
    };
  },
};
</script>

<style lang="scss" scoped>
.page__wrapper {
  background-image: url("~@/assets/backgrounds/bg-thebailey.jpg");
  background-size: cover;
  background-position: center;
}
</style>